/**
 * app人脸识别，使用简易人脸认证流程
 * @param {function} callBack 调用人脸识别功能操作完成后回调函数
 * @param {function} failCallBack 调用人脸识别功能失败的回调函数
 */
export default function appFaceAuth(callBack, failCallBack) {
    window.authCallBack = callBack;
    if (window.CSNativeObject.nativeAuth) {
        window.CSNativeObject.nativeAuth(JSON.stringify({
            simpleFaceChannel: 'true',
            callBackMethod: 'authCallBack',
            channel: 'REFUND_TICKET',
        }));
        return false;
    }
    failCallBack();
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/appFaceAuth.js
// module id = null
// module chunks = 